//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminUserController_getUsers,
  Response$AdminUserController_getUsers$Status$200,
  ResponseContentType$AdminUserController_getUsers,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminUserController_getUsers = (options: {
  params: Params$AdminUserController_getUsers['parameter'];
  config?: QueryOptions<
    Response$AdminUserController_getUsers$Status$200[ResponseContentType$AdminUserController_getUsers]
  >;
}) =>
  useApiClient<
    Params$AdminUserController_getUsers,
    Response$AdminUserController_getUsers$Status$200[ResponseContentType$AdminUserController_getUsers]
  >({
    method: 'AdminUserController_getUsers',
    params: { parameter: options.params },
    config: options.config,
  });
